/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FlightCheckoutBaggageAllowance } from "./FlightCheckoutBaggageAllowance";
import {
  FlightCheckoutBaggageAllowanceFromJSON,
  FlightCheckoutBaggageAllowanceFromJSONTyped,
  FlightCheckoutBaggageAllowanceToJSON,
  FlightCheckoutBaggageAllowanceToJSONTyped,
} from "./FlightCheckoutBaggageAllowance";
import type { FlightModificationPolicy } from "./FlightModificationPolicy";
import {
  FlightModificationPolicyFromJSON,
  FlightModificationPolicyFromJSONTyped,
  FlightModificationPolicyToJSON,
  FlightModificationPolicyToJSONTyped,
} from "./FlightModificationPolicy";

/**
 *
 * @export
 * @interface FlightCheckoutFare
 */
export interface FlightCheckoutFare {
  /**
   * Programs permitted for booking-time attachment. Missing or null is unknown, empty means none. Does not promise benefits.
   * @type {Array<string>}
   * @memberof FlightCheckoutFare
   */
  supportedLoyaltyProgrammes?: Array<string> | null;
  /**
   *
   * @type {string}
   * @memberof FlightCheckoutFare
   */
  cabin?: string | null;
  /**
   *
   * @type {string}
   * @memberof FlightCheckoutFare
   */
  fareBrand?: string | null;
  /**
   *
   * @type {string}
   * @memberof FlightCheckoutFare
   */
  bookingClass?: string | null;
  /**
   *
   * @type {string}
   * @memberof FlightCheckoutFare
   */
  fareBasisCode?: string | null;
  /**
   *
   * @type {Array<FlightCheckoutBaggageAllowance>}
   * @memberof FlightCheckoutFare
   */
  baggage: Array<FlightCheckoutBaggageAllowance>;
  /**
   *
   * @type {FlightModificationPolicy}
   * @memberof FlightCheckoutFare
   */
  changeBeforeDeparture?: FlightModificationPolicy | null;
  /**
   *
   * @type {FlightModificationPolicy}
   * @memberof FlightCheckoutFare
   */
  refundBeforeDeparture?: FlightModificationPolicy | null;
}

/**
 * Check if a given object implements the FlightCheckoutFare interface.
 */
export function instanceOfFlightCheckoutFare(
  value: object
): value is FlightCheckoutFare {
  if (!("baggage" in value) || value["baggage"] === undefined) return false;
  return true;
}

export function FlightCheckoutFareFromJSON(json: any): FlightCheckoutFare {
  return FlightCheckoutFareFromJSONTyped(json, false);
}

export function FlightCheckoutFareFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightCheckoutFare {
  if (json == null) {
    return json;
  }
  return {
    supportedLoyaltyProgrammes:
      json["supported_loyalty_programmes"] == null
        ? undefined
        : json["supported_loyalty_programmes"],
    cabin: json["cabin"] == null ? undefined : json["cabin"],
    fareBrand: json["fare_brand"] == null ? undefined : json["fare_brand"],
    bookingClass:
      json["booking_class"] == null ? undefined : json["booking_class"],
    fareBasisCode:
      json["fare_basis_code"] == null ? undefined : json["fare_basis_code"],
    baggage: (json["baggage"] as Array<any>).map(
      FlightCheckoutBaggageAllowanceFromJSON
    ),
    changeBeforeDeparture:
      json["change_before_departure"] == null
        ? undefined
        : FlightModificationPolicyFromJSON(json["change_before_departure"]),
    refundBeforeDeparture:
      json["refund_before_departure"] == null
        ? undefined
        : FlightModificationPolicyFromJSON(json["refund_before_departure"]),
  };
}

export function FlightCheckoutFareToJSON(json: any): FlightCheckoutFare {
  return FlightCheckoutFareToJSONTyped(json, false);
}

export function FlightCheckoutFareToJSONTyped(
  value?: FlightCheckoutFare | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    supported_loyalty_programmes: value["supportedLoyaltyProgrammes"],
    cabin: value["cabin"],
    fare_brand: value["fareBrand"],
    booking_class: value["bookingClass"],
    fare_basis_code: value["fareBasisCode"],
    baggage: (value["baggage"] as Array<any>).map(
      FlightCheckoutBaggageAllowanceToJSON
    ),
    change_before_departure: FlightModificationPolicyToJSON(
      value["changeBeforeDeparture"]
    ),
    refund_before_departure: FlightModificationPolicyToJSON(
      value["refundBeforeDeparture"]
    ),
  };
}
